$(document).ready(function(){
  M.Sidenav.init($('.sidenav'))
});
